import { FC, ReactElement } from 'react';

import { Box } from '@chakra-ui/react';

import { useEditorStageView } from '../../contexts/EditorStageViewContext';
import type { RenderPreviewArgs } from '../Editor';
import { EditorCenterStageWithSharedResolution } from './EditorCenterStageWithSharedResolution';

export type EditorCenterStageProps = {
  renderPreview?: (args: RenderPreviewArgs) => ReactElement;
  previewArgs: RenderPreviewArgs;
};

export const EditorCenterStage: FC<EditorCenterStageProps> = ({ renderPreview, previewArgs }) => {
  const { showCanvasToggle } = useEditorStageView();

  if (!renderPreview) {
    return null;
  }

  if (!showCanvasToggle) {
    return (
      <Box width="100%" height="100%" overflow="auto" display="flex" flex={1} minH={0}>
        <Box m="auto" onClick={(e) => e.stopPropagation()}>
          {renderPreview(previewArgs)}
        </Box>
      </Box>
    );
  }

  return (
    <Box flex={1} minH={0} width="100%" height="100%" display="flex" flexDirection="column">
      <EditorCenterStageWithSharedResolution
        renderPreview={renderPreview}
        previewArgs={previewArgs}
      />
    </Box>
  );
};

EditorCenterStage.displayName = 'EditorCenterStage';
